/**
 * @module builder
 */

import type { QuoteFile } from 'paintscout'
import { uuid } from '../../../util'

export function createFile(args: { type: string; title?: string }): QuoteFile {
  const { type, title = '' } = args
  return {
    key: uuid(),
    title,
    created: Date.now(),
    type,
    visibility: 'visible'
  }
}
